// Editable placeholder site copy. All content marked [placeholder] is meant to
// be replaced by the publisher before public launch.

export const SITE = {
  name: "Glories of India Publications",
  founder: "Dinesh Chandra Rawat",
  seriesName: "Glories of India Series",
  mission:
    "To explore, preserve and share India's civilizational knowledge through books, field investigation, multidisciplinary research and informed public discussion.",
  tagline: "Rediscovering India Through Evidence, Exploration and Inquiry",
  disclaimer:
    "Materials on this website may include established scholarship, debated interpretations and the author's independent conclusions. Readers are encouraged to consult the cited sources and consider differing scholarly perspectives.",
  contactEmail: "[editable-contact@placeholder.in]",
  addressLines: [
    "Glories of India Publications",
    "[Editable postal address placeholder]",
    "India",
  ],
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Books", to: "/books" },
  { label: "Research Themes", to: "/research-themes" },
  { label: "About the Author", to: "/about" },
  { label: "Join the Mission", to: "/join" },
  { label: "Membership", to: "/membership" },
  { label: "Media", to: "/media" },
  { label: "Articles", to: "/articles" },
  { label: "Events", to: "/events" },
  { label: "Contact", to: "/contact" },
];

export const RESEARCH_PILLARS = [
  { title: "Archaeology", note: "Excavated evidence, dating and material culture." },
  { title: "Ancient Texts and Manuscripts", note: "Primary sources and philological study." },
  { title: "Geography and River Systems", note: "Palaeo-channels, settlements and terrain." },
  { title: "Astronomy and Chronology", note: "Positional astronomy and dating frameworks." },
  { title: "Genetics and Population Studies", note: "Peer-reviewed genetic literature." },
  { title: "Maritime and Overland Trade", note: "Ports, routes and inter-civilizational exchange." },
  { title: "Architecture and Cultural Continuity", note: "Temple, urban and university traditions." },
  { title: "Field Visits and Local Traditions", note: "Site inspection and living oral memory." },
];

export const WHY_CARDS = [
  {
    index: "01",
    title: "Forgotten Historical Questions",
    body: "Return to primary questions that have been set aside in mainstream discourse and reopen them with careful evidence.",
  },
  {
    index: "02",
    title: "Evidence Across Disciplines",
    body: "Read history against archaeology, geography, texts, astronomy and genetics rather than a single lens.",
  },
  {
    index: "03",
    title: "Thirty-Five Years of Exploration",
    body: "Draw upon decades of field visits, reading and comparison across regions and continents.",
  },
  {
    index: "04",
    title: "Knowledge for Future Generations",
    body: "Present the work in a form that students, educators and general readers can engage with responsibly.",
  },
];

export const PARTICIPATION_CARDS = [
  {
    id: "member",
    title: "Become a Member",
    body: "Receive updates, invitations, reading opportunities and access to selected member resources.",
  },
  {
    id: "volunteer",
    title: "Volunteer",
    body: "Contribute through translation, editing, research assistance, video creation, social media or event support.",
  },
  {
    id: "partner",
    title: "Become a Knowledge Partner",
    body: "Collaborate as a researcher, educator, institution, library, publisher or cultural organisation.",
  },
  {
    id: "support",
    title: "Support the Mission",
    body: "Help place books and educational resources in libraries, schools and the hands of interested readers.",
  },
];

export const MISSION_PATHS = [
  { id: "reader", label: "Join as a Reader" },
  { id: "researcher", label: "Join as a Researcher" },
  { id: "educator", label: "Join as an Educator" },
  { id: "student", label: "Join as a Student" },
  { id: "translator", label: "Join as a Translator or Editor" },
  { id: "volunteer", label: "Join as a Volunteer" },
  { id: "library", label: "Join as a Library or Institution" },
  { id: "book_discussion", label: "Organise a Book Discussion" },
  { id: "invite_author", label: "Invite the Author" },
  { id: "sponsor", label: "Sponsor Books for Libraries or Students" },
  { id: "research_lead", label: "Submit a Research Lead" },
  { id: "support", label: "Support the Mission" },
];

export const CONTACT_CATEGORIES = [
  "General enquiry",
  "Book and retail enquiry",
  "Bulk and institutional orders",
  "Media and interview requests",
  "Author speaking invitations",
  "Research collaboration",
  "Technical support",
  "Membership assistance",
];

export const HERO_IMAGES = {
  primary:
    "https://images.pexels.com/photos/35341456/pexels-photo-35341456.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=940",
  manuscript:
    "https://images.unsplash.com/photo-1648717008621-ee7e6acfe270?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxhbmNpZW50JTIwbWFudXNjcmlwdCUyMHRleHR1cmV8ZW58MHx8fHwxNzg0NDI1MDI1fDA&ixlib=rb-4.1.0&q=85&w=900",
  map:
    "https://images.unsplash.com/photo-1723306744533-bed5a4f696dc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwzfHxoaXN0b3JpYyUyMG1hcHxlbnwwfHx8fDE3ODQ0MjUwMjV8MA&ixlib=rb-4.1.0&q=85&w=900",
  astronomy:
    "https://images.pexels.com/photos/37238917/pexels-photo-37238917.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=940",
};
